<template>
<div class="page-of-profile">
  <div class="profile-page">
    <div class="profile-container">
        <div class="image-container">
                <img class="profile-image" src="https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket/red_panda.jpeg" alt="Profile">
        </div>
                <div class="edit-tab"><span class="pi pi-pen-to-square mr-2"> </span> <span class="tab-buttons">  Edit</span></div>

    </div> 
         <div class="profile-details">
                <h2 >{{ ustore.uData.user_metadata.full_name }}</h2>
                <div><span class="pi pi-calendar mr-2"> </span> <span>  joined {{ 
                
                      new Date(ustore.uData.created_at.substring(0,10)).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
      
                    }}</span></div>

          </div>
    <hr class="profile-divider">
    <div class="profile-tab-container">
        <div class="profile-tab" >
            <h4 class="tab-element" v-for="(tabElement,idx) in tabElements" :key="idx" v-bind:class="{'highted-tab':tabElement.condition,'normal-tab': !tabElement.condition}" @click="highlightTab(tabElement)">
                 {{tabElement.name}}
            </h4>
        </div>
        <hr class="tab-divider">
        <div class="tab-content">
            <div v-if="selectedTab=='My Learning'">
                <div><span class="pi pi-book mr-2"> </span> <span class="tab-buttons">  Courses</span></div>
                <div><span class="pi pi-wave-pulse mr-2"> </span> <span class="tab-buttons">  Quizzes</span></div>
                <div @click="generateCertificate"><span class="pi pi-trophy mr-2"> </span> <span class="tab-buttons">  Certificates</span></div>

            </div>
             <div v-if="selectedTab=='Account'">
                <div @click="signout"><span class="pi pi-sign-out mr-2"> </span> <span class="tab-buttons">  Sign Out</span></div>
                <div><span class="pi pi-flag mr-2"> </span> <span class="tab-buttons">  Country</span></div>
            </div>
             <div v-if="selectedTab=='Orders'">
                <div><span class="pi pi-money-bill mr-2"> </span> <span class="tab-buttons">  Purchases</span></div>
            </div>
        </div>
    </div>
  </div>
  </div>
</template>






<script>
import jsPDF from 'jspdf'
// import { useAuthStore } from '@/stores/authStores';
// import {useRouter} from 'vue-router'
import { supabase } from '@/supabase.js';
import { default as ustore } from '@/stores/authStore.js';


export default {
   components: {
 
 
   },
  data() {
    return {
      ustore:ustore,
      profile:{},
      tabElements:[{name:"My Learning",condition:true},{name:"Account",condition:false},{name:"Orders",condition:false}],
      selectedTab:"My Learning",
    };
  },
  


// setup(){
//   const authStore = useAuthStore();
//  const router = useRouter()
//  const logout = async () => {
//       try {
//         await authStore.logout();
//         router.push(`/`)

//       } catch (error) {
//         console.error(error.message);
//       }

//     }
// return{logout}

//     },


  methods: {
   async signout (){
      let { error } = await supabase.auth.signOut()
      console.log(error)
      // this.store.logout()
      this.$router.push(`/`);
    },

   

    createPDF () {
    let pdfName = 'test'; 
    var doc = new jsPDF();
    const certname= this.ustore.uData.user_metadata.full_name
    doc.text(certname, 10, 10);
    doc.save(pdfName + '.pdf');
  },
generateCertificate() {
      // const { jsPDF } = window.jspdf;
      const doc = new jsPDF();
      const studentname= this.ustore.uData.user_metadata.full_name

      // Add title
      doc.setFont("Helvetica", "bold");
      doc.setFontSize(30);
      doc.text("Certificate of Completion", 105, 40, null, null, 'center');

      // Add a decorative line below title
      doc.setLineWidth(0.5);
      doc.line(20, 50, 190, 50);

      // Student and Course Information
      doc.setFont("Helvetica", "normal");
      doc.setFontSize(20);
      doc.text("This is to certify that", 105, 80, null, null, 'center');
      doc.setFontSize(22);
      doc.setFont("Helvetica", "bold");
      doc.text(studentname, 105, 100, null, null, 'center');  // Student's name

      doc.setFontSize(18);
      doc.setFont("Helvetica", "normal");
      doc.text("has successfully completed the course", 105, 120, null, null, 'center');
      doc.setFontSize(20);
      doc.setFont("Helvetica", "bold");
      doc.text("Web Development 101", 105, 140, null, null, 'center');  // Course name

      doc.setFontSize(14);
      doc.setFont("Helvetica", "normal");
      doc.text("on", 105, 160, null, null, 'center');
      doc.setFontSize(16);
      doc.setFont("Helvetica", "italic");
      doc.text("October 30, 2024", 105, 180, null, null, 'center');  // Date

      // Add Signature Section
      doc.setFontSize(14);
      doc.setFont("Helvetica", "normal");
      doc.text("Instructor: Ajatshatru Mishra", 105, 210, null, null, 'center'); // Instructor name

      // Add final signature text at the bottom
      doc.setFontSize(12);
      doc.text("Signature:", 50, 240);
      doc.line(55, 240, 150, 240); // Line for signature

      // Save the PDF
      doc.save("certificate_of_completion.pdf");
  },


  highlightTab (tabElement){
    for (let i = 0; i < this.tabElements.length; i++) {
        if (this.tabElements[i].name===tabElement.name){
            this.tabElements[i].condition=true
            this.selectedTab=this.tabElements[i].name
         }
         else{
            this.tabElements[i].condition=false

         }
    }
  }
  }
 
};
</script>








<style scoped>
.page-of-profile{
  background: #2f2b3a;
  padding:10vh;
}


.profile-page{
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
  /* border: 1px solid gray; */
  min-height: 100vh;
  background: #1a1625;
  justify-content: center; 
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 4%;
  }


.profile-container{
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  }

.image-container{
  margin-left:1%;
}  


.profile-image{
  margin-top: 4%;
  border: 2px solid gray;
  max-width: 220px;
  height: auto;
  border-radius: 4px;
}


.profile-details{
  margin-top: 2%;
  text-align: left;
  margin-left:4%;
  color:ghostwhite;
  height: auto;
  font-size: 100%;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;

}

.profile-divider{
  height: 1px;
  border: transparent; 
  background-color: #cccccc;
  margin-top: 6%;

}

.profile-edit-button{
  margin-top: 5%;
  margin-left: auto;
  width: 100px;
  height: 50px;
  border-radius: 6px;
  cursor: pointer;
  margin-right: 10px;
  background-color: #2b0a5d;
  color: #ffff99;
  border: 2px solid #ffff99;
  font-size: 0.8rem;
  padding: 10px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.profile-tab{
  display:flex;
  gap: 5%;
}

.tab-element{
  font-size: 1.1rem;
  cursor: pointer;
  color:#ffff99;
}



.highlighted-tab{
  color:white;
  display: inline-block; 
  text-decoration: underline; 
  border-bottom: 1px solid black;
  padding-bottom: 3px;

}


.normal-tab{
  color:white;

}

.tab-content{
  margin-left: 2%;
  color: whitesmoke;
  /* display: flex; */
  text-align: left;
  max-width: 50%;
  font-size:105%;
  gap: 50%;
  }

.tab-divider{
  height: 1px;
  border: transparent; 
  background-color:#cccccc;
}

.tab-buttons{
  margin-top: 20px;
  font-size: 18px;
  font-family: Helvetica, sans-serif;
  cursor: pointer;
  display: inline-block;
  transition: background-color 0.3s ease; 
}

.tab-buttons:hover {
        /* background-color: #2b0a5d; */
        color: whitesmoke;
    }


 .edit-tab{
    float: right;
    color: antiquewhite;
  }


@media only screen and (max-width: 800px) {
  .profile-container{
    display: block;
  }

  .edit-tab{
    float: right;
    color: antiquewhite;
  }

  .profile-details{
    margin-top: 50px ;
  }


  .page-of-profile{
    padding: 0%;
  }
}
</style>


